/**
 * this file contains all redux-saga watchers & workers for the fund
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Min on 16/08/18
 */

import { takeEvery, call, put } from 'redux-saga/effects'

import C from '../constants'
import config from '../config'
import { request, isEmpty } from '../utility/utilities'

// import action creators
import * as FundActions from '../actions/fundActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE FUND DATA
----------------------------------------------------------------------------- */

// watcher saga for fetching the fund data
export function* watchFetchFund() {
    yield takeEvery(C.FETCH_FUND_DATA, workerFetchFund)
}

// worker saga for fetching the fund data
function* workerFetchFund() {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.fundFetchURL

    try {

        // show the loader
        yield put(FundActions.showFundLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if(!isEmpty(response.data)) {

            // set the fund data
            yield put(FundActions.setFundInfoData(response.data))
            yield put(FundActions.setMembersTrusteesInfoData(response.data))
        }

    } catch (error) {

    } finally {
        // hide the loader regardless
        yield put(FundActions.showFundLoader(false))
    }
}



// WEBPACK FOOTER //
// ./src/sagas/fundSaga.js